// Union of Macro::ACTIONS_ATTRS and AutomationRule#actions_attributes.
// Maps 1:1 to methods available on ActionService (app/services/action_service.rb)
// plus wait_delay (handled specially by the flow engine via a delayed job).
export const FLOW_ACTION_TYPES = [
  { key: 'send_message', label: 'SEND_MESSAGE', inputType: 'textarea' },
  { key: 'add_private_note', label: 'ADD_PRIVATE_NOTE', inputType: 'textarea' },
  { key: 'assign_agent', label: 'ASSIGN_AGENT', inputType: 'search_select' },
  { key: 'assign_team', label: 'ASSIGN_TEAM', inputType: 'search_select' },
  {
    key: 'remove_assigned_agent',
    label: 'REMOVE_ASSIGNED_AGENT',
    inputType: null,
  },
  {
    key: 'remove_assigned_team',
    label: 'REMOVE_ASSIGNED_TEAM',
    inputType: null,
  },
  { key: 'add_label', label: 'ADD_LABEL', inputType: 'multi_select' },
  { key: 'remove_label', label: 'REMOVE_LABEL', inputType: 'multi_select' },
  { key: 'mute_conversation', label: 'MUTE_CONVERSATION', inputType: null },
  {
    key: 'snooze_conversation',
    label: 'SNOOZE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'RESOLVE_CONVERSATION',
    inputType: null,
  },
  { key: 'open_conversation', label: 'OPEN_CONVERSATION', inputType: null },
  {
    key: 'pending_conversation',
    label: 'PENDING_CONVERSATION',
    inputType: null,
  },
  { key: 'change_status', label: 'CHANGE_STATUS', inputType: 'search_select' },
  {
    key: 'change_priority',
    label: 'CHANGE_PRIORITY',
    inputType: 'search_select',
  },
  {
    key: 'send_email_transcript',
    label: 'SEND_EMAIL_TRANSCRIPT',
    inputType: 'email',
  },
  { key: 'send_webhook_event', label: 'SEND_WEBHOOK_EVENT', inputType: 'url' },
  { key: 'wait_delay', label: 'WAIT_DELAY', inputType: 'number' },
];

export const FLOW_TRIGGER_EVENTS = [
  'conversation_created',
  'conversation_updated',
  'conversation_opened',
  'conversation_resolved',
  'message_created',
];
